export const INVITE_URL = "https://invite.dueutil.tech";
export const SUPPORT_SERVER = "https://discord.gg/JyQEsKw";
export const EMAIL = "macdue@dueutil.tech";
export const DONATE_URL = 'https://donatebot.io/checkout/213007664005775360';

export const setTitle = (title) => {
  document.title = `DueUtil - ${title}`;
}
